export default class NumberHelpers {

    convertNumberWithCommas = (number, prefix) => {
        prefix = !prefix ? "" : prefix.toString();
        return prefix + number.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    safeParseFloat = (value, decimalPlaces = null) => {
        if (!value) return 0;
        if (typeof value === 'string') {
            // Remove all characters except numbers, decimal point, and minus sign
            value = value.replace(/[^0-9.-]+/g, "");
            
            // Handle multiple decimal points by keeping only the first one
            const parts = value.split('.');
            if (parts.length > 1) {
                // Remove leading zeros from the whole number part, but keep single 0 for decimal numbers
                const wholeNumber = parts[0] === '' ? '0' : parts[0].replace(/^0+/, '') || '0';
                
                // If decimal places limit is set and we're not still typing (no trailing decimal)
                if (decimalPlaces !== null && !value.endsWith('.')) {
                    const decimals = parts[1].slice(0, decimalPlaces);
                    value = `${wholeNumber}.${decimals}`;
                } else {
                    value = wholeNumber + '.' + parts.slice(1).join('');
                }
            } else {
                // For whole numbers, remove leading zeros
                value = value.replace(/^0+/, '') || '0';
            }
    
            // If it's just a decimal point, return 0
            if (value === '.') return 0;
            
            // If it ends with decimal, keep it as is to allow continued input
            if (value.endsWith('.')) {
                return value;
            }
        }
    
        if (isNaN(parseFloat(value))) return 0;
        
        // Apply decimal places limit to the final number if specified
        if (decimalPlaces !== null) {
            return Number(parseFloat(value).toFixed(decimalPlaces));
        }
        
        return parseFloat(value);
    };
    
    
    
}